import React, { useLayoutEffect, useMemo } from 'react';
import { useCountry, Country } from '@increasecard/increase-core';
import { Switch, Route, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LeftColumn from '../../common/components/LeftColumn';
import { ContentCard, ContentWrapper } from '../../common/components/ContentCard';
import { BusinessSettingsScreen } from './BusinessSettingsScreen';
import { UsersScreen } from './UsersScreen';
import { EditUserScreen } from './EditUserScreen';
import { Constants } from '@card/commonlib';

const DEFAULT_OPTION = {
  id: 'shop',
  pathname: '/settings'
};

const getLinks = (t: (arg0: string) => string, pathname: string, country: string) => {
  const links = [
    {
      id: DEFAULT_OPTION.id,
      href: '/settings',
      label: t(`abm:LeftColumn:shops`),
      active: pathname === DEFAULT_OPTION.pathname,
      notAvailableIn: [Constants.Countries.ECUADOR, Constants.Countries.DOMINICANA],
      enabled: true
    },
    {
      id: 'users',
      href: '/settings/users',
      label: t(`abm:LeftColumn:users`),
      active: pathname === '/settings/users',
      enabled: true
    },
    {
      id: 'notifications',
      href: '/settings/notifications',
      label: t(`abm:LeftColumn:notifications`),
      active: pathname === '/settings/notifications',
      enabled: false
    }
  ];
  return links.filter((link) => {
    if (!link.enabled || (link.notAvailableIn && link.notAvailableIn.includes(country))) {
      // link not enabled || not available in user's country
      return false;
    }
    return true;
  });
};

export function SettingsScreen() {
  const { t } = useTranslation();
  const history = useHistory();
  const country = useCountry() as Country;
  const availableLinks = useMemo(() => getLinks(t, history.location.pathname, country), [
    t,
    history.location.pathname,
    country
  ]);

  useLayoutEffect(() => {
    if (
      history.location.pathname === DEFAULT_OPTION.pathname &&
      availableLinks[0].id !== DEFAULT_OPTION.id
    ) {
      // if its navigating to default option and is not available => redirect to the first one available
      // Shop settings (default) are not available for users from ECU and DOM
      history.push(availableLinks[0].href);
    }
  }, [availableLinks, history]);

  return (
    <React.Fragment>
      <LeftColumn links={availableLinks} />
      <ContentCard>
        <ContentWrapper>
          <Switch>
            <Route component={BusinessSettingsScreen} exact path="/settings" />
            <Route component={UsersScreen} exact path="/settings/users" />
            <Route component={EditUserScreen} exact path="/settings/users/edit/:id" />
          </Switch>
        </ContentWrapper>
      </ContentCard>
    </React.Fragment>
  );
}
